/** Gerçek `ProductListSection` ile aynı dış yapı — ekstra max-w/padding ile grid daralmaz. */
export default function ProductsListingSkeleton({ count = 24 }: { count?: number }) {
  const n = Math.min(Math.max(count, 8), 24);
  return (
    <section
      className="virtualized-product-list w-full min-w-0"
      aria-busy="true"
      aria-live="polite"
      aria-label="Ürünler yükleniyor"
    >
      {/*
        product-grid global'de justify-center + grid-template-rows: repeat(2,1fr) var;
        pending sırasında grid kutusu dar kalıp ortalanabiliyor. Tam genişlik + normal justify.
      */}
      <div className="product-grid !overflow-visible w-full min-w-0 !justify-normal [grid-template-rows:none]">
        {Array.from({ length: n }).map((_, i) => (
          <div key={i} className="product-grid-item">
            <article className="product-card mb-4">
              <div className="animate-pulse">
                <div className="product-card-image bg-white">
                  <div className="absolute inset-0 bg-neutral-300" />
                </div>

                <div className="product-card-content">
                  <div className="h-4 rounded-md bg-neutral-400/80 w-4/5" />
                  <div className="h-4 rounded-md bg-neutral-400/80 w-3/5" />

                  <div className="product-card-price-container">
                    <div className="product-card-price-wrapper">
                      <div className="product-card-old-price">
                        <div className="h-3 w-16 rounded bg-neutral-400/80" />
                      </div>
                      <div className="product-card-current-price">
                        <div className="h-4 w-24 rounded-md bg-neutral-400/80" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        ))}
      </div>
    </section>
  );
}
